import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CONFIGURATION, ENVIRONMENT } from './injection-tokens';
import { ConfigurationInterface, EnvironmentInterface } from './interfaces';

export function provideConfiguration(
  environment: EnvironmentInterface,
  configuration: ConfigurationInterface,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ENVIRONMENT, useValue: environment },
    { provide: CONFIGURATION, useValue: configuration },
  ]);
}
